import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

let ctx = null;
const KEY = "pame3d_sound";
const enabled = () => localStorage.getItem(KEY) !== "off";
const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, { t = 0, dur = 0.12, type = "sine", vol = 0.18 } = {}) => {
  const c = ac(), o = c.createOscillator(), g = c.createGain();
  const start = c.currentTime + t;
  o.type = type; o.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(vol, start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  o.connect(g).connect(c.destination);
  o.start(start); o.stop(start + dur + 0.02);
};

const safe = (fn) => { try { if (enabled()) fn(); } catch {} };

export const sfx = {
  place: () => safe(() => tone(520, { dur: 0.1, type: "triangle" })),
  remove: () => safe(() => tone(300, { dur: 0.12, type: "triangle", vol: 0.12 })),
  select: () => safe(() => tone(720, { dur: 0.06, vol: 0.08 })),
  wrong: () => safe(() => { tone(260, { dur: 0.16, type: "square", vol: 0.06 }); tone(200, { t: 0.14, dur: 0.2, type: "square", vol: 0.06 }); }),
  success: () => safe(() => [523, 659, 784, 1047].forEach((f, i) => tone(f, { t: i * 0.11, dur: 0.28, vol: 0.16 }))),
};

export const SoundToggle = () => {
  const [on, setOn] = useState(enabled());
  const toggle = () => {
    const next = !on;
    localStorage.setItem(KEY, next ? "on" : "off");
    setOn(next);
    if (next) sfx.select();
  };
  return (
    <button data-testid="sound-toggle" onClick={toggle} aria-pressed={on} title={on ? "Sonido activado" : "Sonido silenciado"}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-2 text-xs font-semibold border transition-colors duration-200 ${
        on ? "bg-white text-[#132A1D] border-black/10 hover:bg-[#2E5A3B]/10" : "bg-black/5 text-[#5C5C5C] border-transparent"}`}>
      {on ? <Volume2 size={14} /> : <VolumeX size={14} />}
    </button>
  );
};
